import { Box, Typography, Avatar, Card, CardContent, CardActions, Stack, Paper, Divider } from '@mui/material';
import { formatDate, formatNumber } from '../../lib/format';
import { hasBreakdown, platformColor, platformIconData } from '../../lib/social';
import BreakdownBars from '../../components/BreakdownBars';
import Button from '../../components/Button';

function SocialCard({ social, onAddMetrics, onDelete }) {
  const hasMetrics = social.followers > 0;
  const visibility = social.metricsVisibility || {};
  const stats = social.stats || {};
  const insights = [
    { key: 'gender', label: 'Gender', visible: visibility.gender !== false, items: stats.genderBreakdown || [] },
    { key: 'ageRange', label: 'Age range', visible: visibility.ageRange !== false, items: stats.ageBreakdown || [] },
    { key: 'location', label: 'Location', visible: visibility.location !== false, items: stats.locationBreakdown || [] },
  ].filter((section) => hasBreakdown(section.items));

  return (
    <Card variant="outlined" sx={{ borderLeft: 4, borderLeftColor: platformColor(social.platform) }}>
      <CardContent>
        <Stack direction="row" spacing={2} sx={{ alignItems: 'flex-start' }}>
          <Avatar src={platformIconData(social.platform)} variant="rounded" />
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="h6">{social.platform}</Typography>
            <Typography color="text.secondary">{social.handle}</Typography>
          </Box>
          {/*<Badge tone={social.ownership === 'Connected' ? 'success' : 'neutral'}>{social.ownership}</Badge>*/}
        </Stack>
        {social.lastChecked && (
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
            Last checked {formatDate(social.lastChecked)}
          </Typography>
        )}
        {hasMetrics ? (
          <Paper variant="outlined" sx={{ mt: 1.5, p: 1.5, display: 'inline-block' }}>
            <Typography variant="h6">{formatNumber(social.followers)}</Typography>
            <Typography variant="body2" color="text.secondary">
              followers
            </Typography>
          </Paper>
        ) : (
          <Typography color="text.secondary" sx={{ mt: 1.5, fontStyle: 'italic' }}>
            Add your audience insights now.
          </Typography>
        )}
        {insights.length > 0 && (
          <Paper variant="outlined" sx={{ mt: 1.5, p: 1.5 }}>
            <Typography variant="overline" color="text.secondary">
              Audience insights
            </Typography>
            <Stack spacing={1.5} divider={<Divider />} sx={{ mt: 0.5 }}>
              {insights.map((section) => (
                <Box key={section.key}>
                  <Typography variant="body2" fontWeight={600} sx={{ mb: 0.75 }}>
                    {section.label}
                  </Typography>
                  <BreakdownBars items={section.items} />
                </Box>
              ))}
            </Stack>
          </Paper>
        )}
      </CardContent>
      <CardActions>
        <Button variant="secondary" onClick={onAddMetrics}>
          {hasMetrics ? 'Edit audience insights' : 'Add audience insights'}
        </Button>
        <Button variant="danger" onClick={onDelete}>
          Delete
        </Button>
      </CardActions>
    </Card>
  );
}

export default SocialCard;
